import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  PostOutboundOAuthRedirectURLResponseTO,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import API from 'services/API';

export const OUTBOUND_OAUTH_REDIRECT_URL_BASE_QUERY_KEY =
  'outbound-oauth-redirect-url';

type ReactQueryOptions = Omit<
  UseQueryOptions<
    PostOutboundOAuthRedirectURLResponseTO['oauthDetails']['redirectUrl']
  >,
  'queryKey' | 'queryFn'
>;

type UseRedirectURLArgs = ReactQueryOptions & {
  integrationEnum: IntegrationEnum;
};

const useRedirectURL = ({
  integrationEnum,
  enabled = true,
  ...options
}: UseRedirectURLArgs) => {
  return useAppQuery<
    PostOutboundOAuthRedirectURLResponseTO['oauthDetails']['redirectUrl']
  >({
    queryKey: [OUTBOUND_OAUTH_REDIRECT_URL_BASE_QUERY_KEY, integrationEnum],
    queryFn: async () => {
      const response = await API.post<PostOutboundOAuthRedirectURLResponseTO>(
        `/api/internal/integrations/outbound/${integrationEnum}/oauth`,
      );

      return response.data.oauthDetails.redirectUrl;
    },
    enabled,
    ...options,
  });
};

export default useRedirectURL;
